import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { WebSocketProvider } from './contexts/WebSocketContext';
import { ApiProvider } from './contexts/ApiContext';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import DashboardPage from './pages/DashboardPage';
import ProjectsPage from './pages/ProjectsPage';
import ProblemsPage from './pages/ProblemsPage';
import HypothesesPage from './pages/HypothesesPage';
import MatrixPage from './pages/MatrixPage';
import ReportsPage from './pages/ReportsPage';
import NotFoundPage from './pages/NotFoundPage';
import LoginPage from './pages/LoginPage';
import AdminPage from './pages/AdminPage';
import DemoViewerPage from './pages/DemoViewerPage';
import WaitlistPage from './pages/WaitlistPage';

const App: React.FC = () => {
  return (
    <Router basename="/app">
      <AuthProvider>
        <Routes>
          {/* Public routes - accessible without authentication */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/demo" element={<DemoViewerPage />} />
          <Route path="/waitlist" element={<WaitlistPage />} />
          
          {/* All other routes require authentication */}
          <Route path="/*" element={
            <ProtectedRoute>
              <WebSocketProvider>
                <ApiProvider>
                  <Layout>
                    <Routes>
                      <Route path="/" element={<Navigate to="/dashboard" replace />} />
                      <Route path="/dashboard" element={<DashboardPage />} />
                      
                      {/* Projects routes - using search params for different views */}
                      <Route path="/app-projects" element={<ProjectsPage />} />
                      <Route path="/app-projects/*" element={<ProjectsPage />} />
                      
                      {/* Problems routes */}
                      <Route path="/app-problems" element={<ProblemsPage />} />
                      <Route path="/app-problems/new" element={<ProblemsPage />} />
                      <Route path="/app-problems/:id" element={<ProblemsPage />} />
                      <Route path="/app-problems/:id/edit" element={<ProblemsPage />} />
                      
                      {/* Hypotheses routes */}
                      <Route path="/app-hypotheses" element={<HypothesesPage />} />
                      <Route path="/app-hypotheses/new" element={<HypothesesPage />} />
                      <Route path="/app-hypotheses/:id" element={<HypothesesPage />} />
                      <Route path="/app-hypotheses/:id/edit" element={<HypothesesPage />} />
                      
                      <Route path="/matrix" element={<MatrixPage />} />
                      <Route path="/reports" element={<ReportsPage />} />
                      <Route path="/admin" element={<AdminPage />} />
                      <Route path="*" element={<NotFoundPage />} />
                    </Routes>
                  </Layout>
                </ApiProvider>
              </WebSocketProvider>
            </ProtectedRoute>
          } />
        </Routes>
      </AuthProvider>
    </Router>
  );
};

export default App;
